import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Spinner } from "react-bootstrap";
import TabellaLista from "../../../components/Tabella/TabellaLista";
import { ChipFilter, filtroMultiplo } from "../../../components/Tabella/ChipFilter";
import MyApiClient from "../../../../api-client/MyApiClient";
import DEFAULT_USER from "../../../../images/DEFAULT_USER.png";
import { dateTimeSort } from "../../../components/Util/oders";
import { caricaDocumentiDaValidare } from "./documentiDaValidare";

// Valori del filtro a chip, come compaiono nella lista.
const TIPOLOGIA_OPTIONS = ['Certificato medico', 'Tesserino', 'Titolo di studio'];

export const ListaDocumenti = () => {

    const navigate = useNavigate();

    const [data_json, setDataJson] = useState(null);
    // Chip a scelta multipla: all'inizio tutti accesi
    const [tipologiaFilter, setTipologiaFilter] = useState(TIPOLOGIA_OPTIONS);

    const filteredData = useMemo(
        () =>
            data_json &&
            data_json.filter((row) => filtroMultiplo(tipologiaFilter, TIPOLOGIA_OPTIONS, row.tipologia)),
        [data_json, tipologiaFilter],
    );

    const [loadingShowed, setLoadingShowed] = useState(false);


    const data_column = [
        {
            Header: 'Data caricamento',
            Footer: 'Data caricamento',
            accessor: 'data-caricamento',
            disableGlobalFilter: true,
            sortType: dateTimeSort,
        },
        {
            Header: 'Caricato da',
            Footer: 'Caricato da',
            accessor: 'name',
            Cell: ({ row }) => (
				<div style={{ display: 'flex', alignItems: 'center' }}>
                    <img
                        src={row.original.imageUrl ? row.original.imageUrl : DEFAULT_USER}
                        alt={row.original.name}
                        style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        marginRight: '10px'
                        }}
                    />
                    {row.original.name}
				</div>
			)
        },
        {
            Header: 'Documento',
            Footer: 'Documento',
            accessor: 'nome-documento',
            disableGlobalFilter: true,
        },
        {
            Header: 'Tipologia',
            Footer: 'Tipologia',
            accessor: 'tipologia',
            disableGlobalFilter: true,
        },
        {
            Header: 'Sport',
            Footer: 'Sport',
            accessor: 'sport',
        },
    ];

    // «Scarica», «Convalida» e «Respingi» stanno nella scheda del documento (03/10/2026)
    const apriDocumento = (row) => navigate('/superadmin/documenti/scheda/' + row.documentId, { state: { documento: row } });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const token = JSON.parse(tokenDetailsString).idToken;
                    setLoadingShowed(true);
                    const documenti = await caricaDocumentiDaValidare(new MyApiClient(), token);
                    setLoadingShowed(false);
                    setDataJson(documenti);
                }
            } catch (error) {
                setLoadingShowed(false);
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);

    return (
        <>
            <Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

            <TabellaLista
                cardTitle={'Documenti da validare'}
                pageList={true}
                hasSearch={true}
                searchPlaceholder={'Cerca per nome o sport'}
                hasFilter={false}
                filterControl={
                    <div className="sid-chip-filters">
                        <ChipFilter label="Tipologia" options={TIPOLOGIA_OPTIONS} value={tipologiaFilter} onChange={setTipologiaFilter} multiple />
                    </div>
                }
                hasAddMore={false}
                linkAddMore={'#'}
                data_column={data_column}
                data_json={filteredData}
                openColumn={'name'}
                openRow={(row) => apriDocumento(row)}
                sort_by={'data-caricamento'}
                sort_type={'desc'}
            />
        </>
    )
}

export default ListaDocumenti
